const oidcConfig = {
  authority: process.env.VITE_OIDC_AUTHORITY || 'https://your-keycloak-domain/auth/realms/your-realm',
  client_id: process.env.VITE_OIDC_CLIENT_ID || 'your-client-id',
  redirect_uri: process.env.VITE_OIDC_REDIRECT_URI || window.location.origin + '/login/callback',
  response_type: 'code',
  scope: 'openid profile email',
  post_logout_redirect_uri: process.env.VITE_OIDC_LOGOUT_REDIRECT_URI || window.location.origin + '/login',
  
  // ✅ Enable automatic token refresh
  automaticSilentRenew: true,
  loadUserInfo: false, // Keep disabled to avoid CORS issues
  monitorSession: true, // Enable session monitoring
  
  // Add explicit metadata to avoid discovery issues
  metadata: {
    authorization_endpoint: `${process.env.VITE_OIDC_AUTHORITY}/protocol/openid-connect/auth`,
    token_endpoint: `${process.env.VITE_OIDC_AUTHORITY}/protocol/openid-connect/token`,
    userinfo_endpoint: `${process.env.VITE_OIDC_AUTHORITY}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${process.env.VITE_OIDC_AUTHORITY}/protocol/openid-connect/logout`,
    jwks_uri: `${process.env.VITE_OIDC_AUTHORITY}/protocol/openid-connect/certs`,
  },
  
  // Additional settings for better compatibility
  checkSessionInterval: 2000,
  silent_redirect_uri: window.location.origin + '/silent-renew.html',
  
  // Disable automatic discovery to avoid CORS issues
  metadataUrl: undefined,
};

export default oidcConfig; 